import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import i18n from '@/utils/i18n';

interface PhoneNumberChangeModalProps {
  isOpen: boolean;
  userName: string;
  onClose: () => void;
  onSubmit: (newPhoneNumber: string) => void;
}

export const PhoneNumberChangeModal: React.FC<PhoneNumberChangeModalProps> = ({
  isOpen,
  userName,
  onClose,
  onSubmit,
}) => {
  const [newPhoneNumber, setNewPhoneNumber] = useState('');

  const handleSubmit = () => {
    onSubmit(newPhoneNumber);
    setNewPhoneNumber('');
  };

  const handleClose = () => {
    setNewPhoneNumber('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose}>
      <ModalHeader>
        {i18n.t('Users:changePhoneNumberFor', { userName })}
      </ModalHeader>
      <ModalBody>
        <div className="input-group mb-3">
          <span className="input-group-text" id="basic-addon1">
            {i18n.t('Users:newPhoneNumber')}
          </span>
          <input
            type="text"
            className="form-control"
            onChange={(e) => setNewPhoneNumber(e.target.value)}
            value={newPhoneNumber}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          className="text-white"
          onClick={handleSubmit}
          disabled={!newPhoneNumber}
        >
          {i18n.t('Users:changePhoneNumber')}
        </Button>
        <Button color="secondary" onClick={handleClose}>
          {i18n.t('Common:close')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

interface PhoneNumberConfirmationModalProps {
  isOpen: boolean;
  userName: string;
  oldPhoneNumber: string | null;
  newPhoneNumber: string;
  error: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const PhoneNumberConfirmationModal: React.FC<
  PhoneNumberConfirmationModalProps
> = ({
  isOpen,
  userName,
  oldPhoneNumber,
  newPhoneNumber,
  error,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <ModalHeader>
        {i18n.t('Users:changePhoneNumberFor', { userName })}
      </ModalHeader>
      <ModalBody>
        <p>
          {i18n.t('Users:confirmPhoneNumberChange', {
            oldPhoneNumber,
            newPhoneNumber,
          })}
        </p>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          className="text-white"
          onClick={onConfirm}
          disabled={!newPhoneNumber}
        >
          {i18n.t('Users:changePhoneNumber')}
        </Button>
        <Button color="secondary" onClick={onClose}>
          {i18n.t('Common:close')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
